export const TEXT = {
  text51: "The ideal place to live unforgettable EAO moments.",
  text52:
    "This 5 stars hotel, fully renovated in 2021, is tucked in the wonderful, soothing and charming Sintra-Cascais Natural Park and surrounded by the Quinta da Marinha Golf Course.",
  text53:
    "It is the ideal place to enjoy moments of learning, networking, playing sports and relaxing.",
  text61:
    "* 100% refundable without cancellation fees under conditions. Consult useful information below to find out more.",
  text612: "Not yet a member? Become an ",
  text613: "EAO member ",
  text614: "today and ",
  text615: "save €300",
  text62: "Full membership (incl joining fee):",
  text63: " Member over 65:",
  text64: " Student membership:",
  text65: "Young Professional membership:",
  text66: "* Book today to secure your place at no risk!",
  text67: "100% refund",
  text68: "in case of cancellation - see",
  text69: "on cancellations below.",

  text7:
    "Special COVID clause: book at no risk until May 1st, 2022. Find out more about prices, cancellation conditions, access, accommodation & insurance.",
  text9:
    "As one of the leading associations within the field of implant dentistry in the world, the EAO aims to improve the quality of patient care by bridging the gap between science and clinical practice.",
  text91: "EAO Office",
  text92: "38 rue Croix des Petits Champs,",
  text921: "75001 Paris,",
  text922: "France +33 (0)1 42 36 62 20",
  text923: "info@eao.org",
  text93: "Terms & Conditions",
  text94: "Privacy policy",
  text95: "Legals",
};

export const PRICE = {
  price1: "€280 ",
  price2: "€50 ",
  price3: "€50 ",
  price4: "€145 ",
};
